module.exports = __webpack_public_path__ + "static/media/small-check.7e15eadd.svg";